/**
 * 会话费用格式化（人民币）。
 * 金额很小（DeepSeek 单次调用常为厘级），按量级自适应精度：
 *  ≥100 元取整；≥1 元两位小数；≥0.01 元两位小数；不足一分钱保留三位小数。
 * 无法计算的费用（模型未配置价格）返回 null，调用方不渲染标签。
 */
export function formatCostCny(cost: number | null | undefined): string | null {
  if (cost === null || cost === undefined || !Number.isFinite(cost)) return null;
  if (cost >= 100) return `¥${Math.round(cost)}`;
  if (cost >= 1) return `¥${cost.toFixed(2)}`;
  if (cost >= 0.01) return `¥${cost.toFixed(2)}`;
  return `¥${cost.toFixed(3)}`;
}
